import { QuestionnaireAnswerType } from 'components/Assessments/types'
import { SensoryQuestionnaireItem } from './questionnaire'

export const SENSORY_QUESTIONNAIRE_ITEM_TO_ANSWER_TYPE = {
  [SensoryQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EYES]:
    QuestionnaireAnswerType.STRING,
  [SensoryQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_EARS]:
    QuestionnaireAnswerType.STRING,
  [SensoryQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_NOSE]:
    QuestionnaireAnswerType.STRING,
  [SensoryQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TOUCH]:
    QuestionnaireAnswerType.STRING,
  [SensoryQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SENSORY_STATUS_TASTE]:
    QuestionnaireAnswerType.STRING,
  [SensoryQuestionnaireItem.MEDICAL_BACKGROUND_SENSORY_SYSTEM_SUMMARY]:
    QuestionnaireAnswerType.STRING
}
